import { render, staticRenderFns } from "./ModalBackofficeRenovarAutorizacao.vue?vue&type=template&id=374455cc"
import script from "./ModalBackofficeRenovarAutorizacao.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeRenovarAutorizacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports